import React from 'react';
import { Grid, makeStyles, Typography } from '@material-ui/core';

import { Navigation } from 'common';
import SkillSelector from './skillSelector';
import SkillsScore from './skillsScore';
import { SkillRecommendationProvider } from './context';

const useStyles = makeStyles(() => ({
  container: {
    padding: '56px 48px 24px',
    background: '#fbfbfb',
    position: 'relative',
    marginTop: 25,
    minHeight: 'calc(100vh - 48px)',
    alignContent: 'flex-start',
  },
  title: {
    opacity: 0.6,
    fontFamily: 'Roboto',
    fontSize: 16,
    letterSpacing: 0.16,
    color: '#000',
  },
  contentContainer: {
    paddingTop: 20,
  },
  contentGrid: {
    paddingRight: 32,
  },
}));

const SkillsRecommendation = () => {
  const classes = useStyles();

  return (
    <>
      <Navigation />
      <SkillRecommendationProvider>
        <Grid container classes={{ root: classes.container }}>
          <Typography classes={{ root: classes.title }}>
            Select two skills which you want to compare
          </Typography>
          <Grid container classes={{ root: classes.contentContainer }}>
            <Grid item xs={4} classes={{ root: classes.contentGrid }}>
              <SkillSelector label="Select Skill 1" skillSet={'skillSet1'} />
            </Grid>
            <Grid item xs={4} classes={{ root: classes.contentGrid }}>
              <SkillSelector label="Select Skill 2" skillSet={'skillSet2'} />
            </Grid>
            <Grid item xs={4}>
              <SkillsScore />
            </Grid>
          </Grid>
        </Grid>
      </SkillRecommendationProvider>
    </>
  );
};

export default SkillsRecommendation;
